<template>
  <div>
    <el-alert
      :closable="false"
      title="温馨提示"
      description="为能给医生及患者提供更多的安全保证，医生只要信息经过审核通过以后，才可以对患者问诊。审核通过后,我的资质与实名认证信息不能更改。如果审核被拒，请根据审核失败信息，补充并提交信息。隐私信息未经本人许可严格保密。"
      type="info"
      show-icon
    >
    </el-alert>

    <div class="userInfo">
      <!-- 医生头像 -->
      <div class="head-img-warp">
        <div class="head-img">
          <img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar" />
          <img
            v-else
            src="../../../assets/images/default-avatar-doctor.png"
            class="avatar"
          />
        </div>
        <el-button @click="setUserInfo()" type="text" class="edit-btn">
          <span>编辑</span>
          <i class="el-icon-edit-outline"></i>
        </el-button>
      </div>
      <!-- 医生信息 -->
      <div class="user-warp">
        <el-form :model="userInfo" label-width="100px">
          <el-form-item label="真实姓名">
            <el-input
              :value="userInfo.familyName+userInfo.firstName"
              placeholder="真实姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input
              v-model="userInfo.identityCard"
              placeholder="身份证号"
            ></el-input>
          </el-form-item>
          <el-form-item label="性    别">
            <el-radio-group v-model="userInfo.gender">
              <el-radio :label="10901">男</el-radio>
              <el-radio :label="10902">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="出身日期">
            <el-date-picker
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              v-model="userInfo.birthday"
              class="form-item-info"
              :picker-options="pickerOptions0"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="城市">
            <el-input v-model="userInfo.cityName" placeholder="城市"></el-input>
          </el-form-item>
          <el-form-item label="所属医院">
            <el-input
              v-model="userInfo.hospitalName"
              placeholder="所属医院"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属科室">
            <el-input
              v-model="userInfo.departmentName"
              placeholder="所属科室"
            ></el-input>
          </el-form-item>
          <el-form-item label="擅长领域">
            <el-input
              type="textarea"
              v-model="userInfo.adept"
              :rows="3"
              placeholder="擅长领域"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { getDoctorInformation } from "@/api";
export default {
  name: "",
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + "sys/upload/fileUpload",
      ruleForm: {},
      headPortrait: false,
      userInfo: {},
      pickerOptions0: {
        // elementUI不能选择超过当天的日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
    };
  },
  created() {
    this.getDoctorUserInfo();
  },
  methods: {
    // 获取医生信息
    async getDoctorUserInfo() {
      const { code, data } = await getDoctorInformation();
      if (code === 1) {
        this.userInfo = data;
      }
    },
    handleAvatarSuccess(res, file) {
      const that = this;
      that.ruleForm.avatar = res.result.relativePath;
      that.ruleForm.avatarText = res.result.absolutePath;
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "jpg";
      const isLt200k = file.size / 1024 < 200;

      if (!isJPG) {
        this.$message.error("头像图片格式错误");
      }
      if (!isLt200k) {
        this.$message.error("上传头像图片大小不能超过 200KB!");
      }
      return isJPG && isLt200k;
    },
    checkPhoto() {
      this.headPortrait = !this.headPortrait;
    },
    setUserInfo() {
      this.$router.push({
        path: "/index/user/auditInformation",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.userInfo {
  display: flex;
  padding: 10px;
  .avatar-uploader {
    text-align: center;
  }
  .head-img-warp {
    text-align: center;
  }
  .head-img {
    margin: 0 30px;
  }
  .head-img-check {
    text-align: center;
  }
  .avatar {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .head-img-br-span {
    font-size: 10px;
  }
}
.user-warp {
  width: 40%;
}
</style>
